export const version = '2.84.0' // bump-client-version 2025-11-14T18:28:15.098Z
